import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DummyLogo from "../assets/images/dummy-logo.png";
import ACTButton from "./ACTButton";
import DropDownMenu from "./DropDownMenu";
import { AppSelectDropdown } from "./AppSelectDropdown";
import AccountSelectInput from "./AccountSelectInput";
import ACTLogoA from "../assets/images/ACT-A-logo.png";
import { AppContext } from "../context/AppContext";
import TimerHeader from "../TimerHeader";

const menuItems = [
  {
    label: "End Session",
    onClick: () => console.log("End Session"),
  },
  {
    label: "Request new QR Code",
    onClick: () => console.log("Request new QR Code"),
  },
  {
    label: "Contact Tech Support",
    onClick: () => console.log("Contact Tech Support"),
  },
];

const Header = (props) => {
  const { appSelectHandler, defaultAPIKey, goToHome, goToHomePanel } = props;
  const timerRef = useRef();
  const [selectedAPIKey, setSelectedAPIKey] = useState(defaultAPIKey);
  const {
    setAccountId,
    validationStatus,
    setSessionEnded,
    sessionEnded,
    showWebPage,
    setShowWebPage,
  } = useContext(AppContext);
  const [accountIdEntered, setAccountIdEntered] = useState("");

  const onTextEnter = (text) => {
    setAccountIdEntered(text);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleTimerExpire = () => {
    setSessionEnded(true);
  };

  const onRefreshQrCode = () => {
    setAccountId(accountIdEntered);
    goToHome();
  };

  useEffect(() => {}, [showWebPage]);

  const goToDemoPage = () => {
    setShowWebPage(false);
  };

  return (
    <Box
      sx={{
        padding: isMobile ? "0.5rem 0.5rem 0 0.5rem" : "0.5rem 1.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        borderBottom: isMobile ? "none" : "0.15rem #e0e0e0 solid",
        position: "relative",
        minHeight: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: isMobile ? "center" : "flex-start",
          alignItems: isMobile ? "flex-start" : "center",
          gap: isMobile ? "0" : "2rem",
          margin: isMobile ? "0.5rem" : "0",
          width: "100%",
          height: showWebPage & !isMobile ? "4rem" : "auto",
          padding: "0",
        }}
      >
        <img
          src={DummyLogo}
          alt="Dummy Logo"
          style={{
            width: "6rem",
            height: "auto",
            imageRendering: "crisp-edges",
          }}
        />

        {!showWebPage && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: isMobile ? "0.2rem" : "1.25rem",
              width: isMobile
                ? "100%"
                : accountIdEntered.length > 0
                ? "43rem"
                : "28rem",
            }}
          >
            {/* <AppSelectDropdown
              selectedAPIKey={selectedAPIKey}
              defaultAPIKey={defaultAPIKey}
            />
            <AccountSelectInput textHandler={onTextEnter} />

            {accountIdEntered.length > 0 && (
              <ACTButton
                content="Generate QR Code"
                onClick={onRefreshQrCode}
                bgColor="#ffffff"
                textColor="#000000"
                hoverColor="#E54F9C"
                hoverTextColor="#ffffff"
                border="0.1rem solid #000000"
                hoverBorder="0.1rem solid #E54F9C"
                textLineHeight={isMobile ? "1.1" : "auto"}
              />
            )} */}
          </Box>
        )}

        <Box
          sx={{
            position: "absolute",
            display: "flex",
            alignItems: "center",
            right: isMobile ? "0" : "0.5rem",
            top: isMobile ? "1.2rem" : "0.25rem",
          }}
        >
          {validationStatus && validationStatus.expiryTime && !sessionEnded && (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginRight: "1rem",
                  padding: "0",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    fontWeight: "500",
                    margin: isMobile ? "0" : "0 0 -0.2rem 0",
                    lineHeight: isMobile ? "1" : "1.5",
                    padding: "0",
                    textAlign: "right",
                  }}
                >
                  ACTive session:
                </Typography>

                {validationStatus && validationStatus.expiryTime && (
                  <TimerHeader
                    ref={timerRef}
                    expiryTime={validationStatus.expiryTime}
                    onExpire={handleTimerExpire}
                  />
                )}
              </Box>

              {!isMobile && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={ACTLogoA}
                    alt="ACT logo"
                    style={{
                      width: "auto",
                      height: "3rem",
                      imageRendering: "crisp-edges",
                      marginRight: "0.75rem",
                    }}
                  />
                </Box>
              )}
            </>
          )}
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: "0.5rem",
            top: isMobile ? "1.4rem" : "2rem",
          }}
        >
          {/* <DropDownMenu menuItems={menuItems} /> */}
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
